// @flow

const TeamMemberRoleConstants = {
  MAINTAINER: "MAINTAINER",
  MEMBER: "MEMBER"
};

export default TeamMemberRoleConstants;
